import React from "react";
import ReactDOM from "react-dom/client";
import "./css/fonts.css";
import "./index.css";
import "./css/animations.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
window.gtag("config", process.env.REACT_APP_GA_ID);
if (process.env.REACT_APP_ENABLE_LOGS !== "true") {
  console.log = () => {};
}
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
